import React, { Component } from 'react';

import { ref, set } from 'firebase/database';

import AppChrome from '../layout/AppChrome';

class GoalNotificationsStop extends Component {

    constructor(props) {
       super(props);
       this.state = { optedOut : false };
    }

    setNudgesOptOut = () => {
      if (this.props.firebase.user && !this.state.optedOut) {
        set(ref(this.props.firebase.database, 'users/' + this.props.firebase.user.uid + '/settings/goalNotificationsOptOut'), true)
        .then(() => {
            this.setState({ optedOut : true })
         })
        .catch((error) => {
          alert("Error writing document: ", error);
        });
      }
    }

    componentWillMount = () => {
      this.setNudgesOptOut();
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
      this.setNudgesOptOut();
    }

    componentWillUnmount() {
    }

    render = () => {
      var user = this.props.firebase.user
      var history = this.props.history;

      if (user && !user.emailVerified)
        this.props.history.push("/verify-email");

      return (
        <AppChrome title="Goal Notifications" history={history} requireLogin={true} firebase={this.props.firebase} back={true} tab="Today">
            <div><p>You have successfully opted out of goal notification emails</p></div>
        </AppChrome>
      )
      
    }
}

export default GoalNotificationsStop;